import { useState, useEffect } from 'react';
"use strict";
const testMediaElementVolumeSetterAsync = () => {
  const timeoutPromise = new Promise(resolve => setTimeout(resolve, 500, false));
  const promise = new Promise(resolve => {
    let video = document.createElement("video");
    const handler = () => {
      video?.removeEventListener("volumechange", handler);
      video = null;
      resolve(true);
    };
    video.addEventListener("volumechange", handler);
    video.volume = 0.5;
  });
  return Promise.race([promise, timeoutPromise]);
};
const useTestMediaElementVolumeSetter = () => {
  const [isSupported, setIsSupported] = useState(null);
  useEffect(() => {
    testMediaElementVolumeSetterAsync().then(setIsSupported).catch(e => console.error("Cannot detect", e));
  }, []);
  return isSupported;
};
export { useTestMediaElementVolumeSetter };
//# sourceMappingURL=useTestMediaElementVolumeSetter.mjs.map
